import { Typography, useTheme } from '@mui/material';
import { convertConstStringToText } from '@ui-framework/index';
import IconLibrary from './IconLibrary';

export const jobStatusConfig = theme => ({
  INCOMPLETE: {
    label: 'Incomplete',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: IconLibrary.JOB_STATUS_INCOMPLETE,
    iconColor: 'warning',
  },
  PENDING_ACCEPTANCE: {
    label: 'Pending Acceptance',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: IconLibrary.JOB_STATUS_PENDING_ACCEPTANCE,
    iconColor: 'warning',
  },
  CLAIM_IN_PROCESS: {
    label: 'Claim in Process',
    borderColor: theme.palette.primary.dark,
    textColor: 'info',
    Icon: IconLibrary.CLAIM,
    iconColor: 'info',
  },
  CLAIM_COMPLETE: {
    label: 'Claim Complete',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: IconLibrary.CLAIM,
    iconColor: 'info',
  },
  DISPATCH_IN_PROCESS: {
    label: 'Dispatch in Process',
    borderColor: theme.palette.primary.dark,
    textColor: 'info',
    Icon: IconLibrary.JOB_STATUS_DISPATCH_PENDING,
    iconColor: 'info',
  },
  DISPATCH_PENDING: {
    label: 'Dispatch Pending',
    borderColor: theme.palette.primary.dark,
    textColor: 'info',
    Icon: IconLibrary.JOB_STATUS_DISPATCH_PENDING,
    iconColor: 'info',
  },
  CANCELED: {
    label: 'Canceled',
    borderColor: theme.palette.primary.dark,
    textColor: 'error',
    Icon: IconLibrary.JOB_STATUS_CANCELED,
    iconColor: 'error',
  },
  ACTIVE: {
    label: 'Active',
    borderColor: theme.palette.primary.dark,
    textColor: 'info',
    Icon: IconLibrary.JOB_STATUS_ACTIVE,
    iconColor: 'info',
  },
  SERVICE_COMPLETE: {
    label: 'Service Complete',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: IconLibrary.JOB_STATUS_COMPLETE,
    iconColor: 'success',
  },
  COMPLETE: {
    label: 'Complete',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: IconLibrary.JOB_STATUS_COMPLETE,
    iconColor: 'success',
  },
  SERVICE_PENDING: {
    label: 'Service Pending',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: IconLibrary.JOB_STATUS_SERVICE_PENDING,
    iconColor: 'warning',
  },
  PENDING_PREAUTHORIZATION: {
    label: 'Pending Preauthorization',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: IconLibrary.JOB_STATUS_PENDING_PREAUTHORIZATION,
    iconColor: 'warning',
  },
  PENDING_PREAUTHORIZATION_REQUEST: {
    label: 'Pending Preauthorization Request',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: IconLibrary.JOB_STATUS_PENDING_PREAUTHORIZATION_REQUEST,
    iconColor: 'warning',
  },
  INTERVENTION_REQUIRED: {
    label: 'Intervention Required',
    borderColor: theme.palette.primary.dark,
    textColor: 'error',
    Icon: IconLibrary.JOB_STATUS_INTERVENTION_REQUIRED,
    iconColor: 'error',
  },
});

function JobStatus({ children: status, withIcon = false, component = 'p' }) {
  if (!(typeof status === 'string')) return status;

  const theme = useTheme();
  const config = jobStatusConfig(theme);

  if (config?.[status]) {
    const { Icon, label, textColor, iconColor } = config[status];
    return (
      <Typography
        component={component}
        color={textColor}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: theme.palette[textColor]?.main,
        }}>
        {withIcon && Icon && <Icon color={iconColor} fontSize="small" />}
        {label}
      </Typography>
    );
  }

  return (
    <Typography color="inherit" component={component}>
      {convertConstStringToText(status)}
    </Typography>
  );
}

export default JobStatus;
